export default __webpack_public_path__ + "static/media/logo-rtl-dark.9a685029.svg";